const SQL_IN_OPERATOR = '_in_'

/**
 * Returns filter param built from the provided [filters]
 * @param {Object} filters object with key-value pairs where key = name of the filter
 *                         value = selected value
 * @returns {Array<string>} array of filters
 */
export default function objectFilterBuilder(filters) {
    const filter = new Set()
    function processFilterEntry(key, value) {
        let op = '='

        if (Array.isArray(value)) {
            value.forEach(val => {
                let innerOp = op
                if (val instanceof Object) {
                    if ('op' in val) {
                        innerOp = val.op
                    }
                    if ('value' in val) {
                        val = val.value
                        if (Array.isArray(val)) {
                            if (innerOp !== SQL_IN_OPERATOR) {
                                throw TypeError(
                                    'You can only use an array as a value when with the _in_ operator.'
                                )
                            }
                            val = val.join(';')
                        }
                    }
                }
                filter.add(`${key}${innerOp}${val}`)
            })
        } else if (value instanceof Object) {
            if ('op' in value) {
                op = value.op
                if (op !== SQL_IN_OPERATOR && Array.isArray(value)) {
                    throw TypeError(
                        'You can only use an array as a value when with the _in_ operator.'
                    )
                }
            }
            if ('value' in value) {
                value = value.value
                if (Array.isArray(value)) {
                    if (op !== SQL_IN_OPERATOR) {
                        throw TypeError(
                            'You can only use an array as a value when with the _in_ operator.'
                        )
                    }
                    value = value.join(';')
                }
            }
            filter.add(`${key}${op}${value}`)
        } else {
            filter.add(`${key}${op}${value}`)
        }
    }

    Object.entries(filters).forEach(([key, value]) => {
        processFilterEntry(key, value)
    })
    return Array.from(filter)
}

objectFilterBuilder.canMap = function (filters) {
    return filters instanceof Object && !Array.isArray(filters)
}
